module.exports = __webpack_public_path__ + "img/arrow-left.c9507f99.png";